export const formatWalletAddress = (address, length = 8) => {
    if (!address) return
    if (address.length <= length * 2) return address
    return `${address.slice(0, length)}...${address.slice(-length)}`
}
